import classnames from 'classnames/bind';
import React from 'react';
import styles from 'presentation/components/styles/__demo__/DeflectionPanel.css';
import PropTypes from 'prop-types';

let cx = classnames.bind(styles);

class DeflectionPanel extends React.Component {
  constructor(props) {
    super(props);

    const deflectionPanelPropTypes = {
      onClick: PropTypes.func.isRequired,
    };
    PropTypes.checkPropTypes(deflectionPanelPropTypes, props, 'props', 'DeflectionPanel');

    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleClick() {
    this.props.onClick();
  }

  handleKeyDown(ev) {
    if (ev.keyCode == 13 || ev.keyCode == 32) {
      event.preventDefault();
      this.handleClick();
    }
  }

  render() {
    return (
      <div className={cx(styles.deflectionPanel_container)}>
        <div className={cx(styles.deflectionPanel_body)}>
          <div className={cx(styles.deflectionPanel_title)}>Didn't answer your question?</div>
          <div
            className={cx(styles.deflectionPanel_button)}
            onClick={this.handleClick}
            onKeyDown={this.handleKeyDown}
            role="button"
            tabIndex="0"
          >
            Let's Chat
          </div>
        </div>
      </div>
    );
  }
}

export default DeflectionPanel;
